import actions from "@/store/actions/paymentAction";
import mutations from "@/store/mutations/paymentMutation";
import getters from "@/store/getters/paymentGetter";
/**
 *  payment
 */

export default {
  state: {
    initIapStatus: false
  },
  actions: actions,
  mutations: mutations,
  getters: getters
};